<template>
    <transition-group name="list">
        <div
        v-for="(email, index) in emailsInputList"
        class="contact-wrapper"
        :key="`sendInfoEmail${index}`"
        :class="{ 'mobile': isMobile, 'phone-contact': email.isPhoneContact }">
            <!-- NOTE i dont see this on design, but it wil probably be needed -->
            <!-- <contact-item
            v-if="email.isPhoneContact"
            :phoneContactData="email.phoneContactData"
            withActions
            sendType="email"
            @clear="emit('removeDestinationValue', index)"
            @contactButtonClicked="contactButtonClickHandler(index)"/> -->
            <!-- Manual Input -->
            <input-generic
            class="inputs-size"
            :params="email"
            :inputValue="destinationValues[index]"
            :rightButtonIcon="destinationValues.length > 1 ? 'close': rightButtonIcon"
            @input="[emit('updateDestinationValue', { index: index, value: $event }), removeInputsError(index)]"
            @onBlur="[validateInputValue(index), emit('calcHeight')]"
            @rightButtonClicked="destinationValues.length > 1 ? removeLineHandler(index) : contactButtonClickHandler(index)"/>
        </div>
    </transition-group>
</template>

<script setup>
import InputGeneric from '@/components/generic/inputs/Generic'
// import ContactItem from '@/components/generic/modals/side/contacts/ContactItem'
/* Vue & Assets */
import { ref, computed, watch, onMounted } from 'vue'
import { emailValidator } from '@/assets/scripts/validators'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['updateDestinationValue', 'removeDestinationValue', 'resetValidationTriggerProp', 'sendInfo', 'rightButtonClicked', 'calcHeight'])

/* Props
@destinationValues {Array} - list of emails values
@validateDestinationValues {Boolean} - prop to trigger all inputs validation
@rightButtonIcon { String } Icon to show right button
@isMobile {Boolean}
*/
const props = defineProps({
    destinationValues: Array,
    validateDestinationValues: Boolean,
    rightButtonIcon: String,
    isMobile: Boolean
})

/*************************************************
*                                                *
*             Inputs Validations Logic           *
*                                                *
*************************************************/
const validateInputsValueBeforeSend = () => {
    let hasError = false
    emailsInputList.value.forEach((input, index) => {
        const destinationValue = props.destinationValues[index]
        const targetValue = destinationValue.isPhoneContact ? destinationValue.contactData : destinationValue
        if (!targetValue.length) {
            input.errorState = true
            input.errorMessage = t('mandatoryFieldError')
            hasError = true
        } else if (!!targetValue.length && !emailValidator(targetValue)) {
            input.errorState = true
            input.errorMessage = t('modals.sendInfo.invalidEmailError')
            hasError = true
        }
    })

    if (isAnyInError.value) hasError = true

    if (!hasError) emit('sendInfo')
}

const validateInputValue = inputIndex => {
    emailsInputList.value.forEach((input, index) => {
        if (index === inputIndex && !!props.destinationValues[index].length && !emailValidator(props.destinationValues[index])) {
            input.errorState = true
            input.errorMessage = t('modals.sendInfo.invalidEmailError')
        }
    })

    let filteredEmails = []
    if (props.destinationValues[inputIndex]) {
        filteredEmails = props.destinationValues.filter(ele => ele === props.destinationValues[inputIndex])
    }

    if (filteredEmails.length > 1) {
        emailsInputList.value[inputIndex].errorState = true
        emailsInputList.value[inputIndex].errorMessage = t('modals.sendInfo.repeatedEmailError')
    }
}

const removeInputsError = inputIndex => {
    emailsInputList.value.forEach((input, index) => {
        if (!inputIndex) input.errorState = false
        else if (inputIndex && inputIndex === index) input.errorState = false
    })
}

const removeLineHandler = inputIndex => {
    let filteredEmails = []
    if (props.destinationValues[inputIndex]) {
        filteredEmails = props.destinationValues.filter(ele => ele === props.destinationValues[inputIndex])
    }

    if (filteredEmails.length === 2) {
        emailsInputList.value.forEach((element, index) => {
            if (props.destinationValues[index] === props.destinationValues[inputIndex]) {
                element.errorState = false
            }
        })
    }

    emit('removeDestinationValue', inputIndex)
}

const isAnyInError = computed(() => {
    let hasError = false

    emailsInputList.value.forEach(element => {
        if (element.errorState) {
            hasError = true
        }
    })

    return hasError
})
/*************************************************
*                                                *
*            InputsList Creation Logic           *
*                                                *
*************************************************/
const emailsInputList = ref([])
const createdEmailInputs = () => {
    emailsInputList.value = props.destinationValues.map((email, index) => {
        return {
            isPhoneContact: email.isPhoneContact,
            phoneContactData: {
                firstName: email.firstName,
                middleName: email.middleName,
                familyName: email.familyName,
                imageData: email.imageData,
                contactData: email.contactData
            },
            labelText: t('modals.sendInfo.emailLabel'),
            placeholder: t('modals.sendInfo.emailPlaceholder'),
            mandatory: true,
            errorState: emailsInputList.value[index] ? emailsInputList.value[index].errorState : false,
            errorMessage: emailsInputList.value[index] ? emailsInputList.value[index].errorMessage : null
        }
    })
}

// When updating a contact
const contactToUpdate = ref(null)
const contactButtonClickHandler = (index) => {
    contactToUpdate.value = index
    emit('rightButtonClicked', index)
}

watch(() => props.validateDestinationValues, (newVal, oldVal) => {
    if (newVal) {
        validateInputsValueBeforeSend()
        emit('resetValidationTriggerProp')
    }
})

watch(() => props.destinationValues.length, () => {
    createdEmailInputs()
})

watch(() => props.destinationValues[contactToUpdate.value], (newVal, oldVal) => {
    if (newVal) {
        createdEmailInputs()
    }
})

onMounted(() => createdEmailInputs())
</script>

<style lang="scss" scoped>
.input-elements-container {
    margin-bottom: 16px;
}

.contact-wrapper {
    min-height: 80px;
    margin-inline: -16px;
    padding-inline: 16px;

    &.phone-contact {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }
}

.list-move,
.list-enter-active,
.list-leave-active {
    transition: all 0.25s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
}
</style>
